<template>
    <section class="container-fluid content-type-37 graph" v-if="audience?.stats">
        <div class="container">
            <div class="row">
                <div class="col-6 col-sm-5 col-sm-offset-1 col-xl-4 col-xl-offset-2">
                    <GraphGauge :value="gaugePercent" :hidePerc="false" />
                </div>

                <div class="col-12 col-sm-6 col-xl-5">
                    <div class="content">
                        <div class="hidden-up visible-sm-up h5 title">{{$t('views.audience.sections.summary.title')}}</div>
                        <ul class="stats">
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.label')}}</div>
                                <div class="value">{{formatNumber(audience.stats.with_label || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.tag')}}</div>
                                <div class="value">{{formatNumber(audience.stats.with_tags || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.owner')}}</div>
                                <div class="value">{{formatNumber(audience.stats.with_owner || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.visits')}}</div>
                                <div class="value">{{formatNumber(audience.stats.with_visits || 0)}}</div>
                            </li>
                            <li class="stat">
                                <div class="name">{{$t('views.audience.sections.summary.contact')}}</div>
                                <div class="value">{{formatNumber(audience.stats.with_contacts || 0)}}</div>
                            </li>
                            <li class="stat highlight">
                                <div class="name">{{$t('views.audience.sections.summary.prospects')}}</div>
                                <div class="value">{{formatNumber(audience.stats.prospects || 0)}}</div>
                            </li>
                                             
                            <li class="stat lowlight">
                                <div class="name">{{$t('views.audience.sections.summary.total')}}</div>
                                <div class="value">{{formatNumber(audience.total)}}</div>
                            </li>
                            <li class="stat lowlight">
                                <div class="name">{{$t('views.audience.sections.summary.duplicates')}}</div>
                                <div class="value">{{formatNumber(audience.stats.total - audience.stats.suspects)}}</div>
                            </li>
                            <li class="stat highlight">
                                <div class="name">{{$t('views.audience.sections.summary.suspects')}}</div>
                                <div class="value">{{formatNumber(audience.stats.suspects)}}</div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudienceStore } from '@/stores/audience';
    import { formatNumber } from '@/utils/formatting';
    import GraphGauge from '@/components/misc/GraphGauge.vue';

    export default {
        name: "AudienceStatsSummary",
        components: { GraphGauge },
        computed: {
            ...mapState(useAudienceStore, ['audience']),
            gaugePercent() {
                if (this.audience?.stats?.suspects) {
                    return Math.round((this.audience.stats.prospects / this.audience.stats.suspects) * 100);
                }
                return 0;
            }
        },
        methods: {
            formatNumber
        },
    }
</script>